import { ViewParams } from 'shared/types/params';
import { createAction } from 'typesafe-actions';

export const saveExternalConfig = createAction('config/SAVE_EXTERNAL_CONFIG')<Partial<ViewParams>>();
